





















export default {
    name: 'prize-details-item',
    props: {
        imageUrl: {
            type: String,
            default: null,
        },
        rankFrom: {
            type: Number,
            default: null,
        },
        rankTo: {
            type: Number,
            default: null,
        },
        order: {
            type: Number,
            default: 1,
        },
        title: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        quantity: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        trophyIcon() {
            if (this.order >= 1 && this.order <= 3) {
                return 'icon-star-trophy';
            }

            return 'icon-normal-trophy';
        },
        ranks() {
            if (this.ranksTo === null || this.rankFrom === null) {
                return null;
            }

            return `${this.rankFrom > 0 && this.rankFrom !== this.rankTo ? this.rankFrom + ' - ' : ''}${this.rankTo}`;
        },
    },
};
